module.exports = __webpack_public_path__ + "public/img/应急工作组bg.c03d5b55.png";